import { InitOverrideFunction, SettingsApi } from "../../../@api";

export class SettingsApiService
  implements Omit<SettingsApi, `${string}Raw` | "withMiddleware" | "withPreMiddleware" | "withPostMiddleware">
{
  constructor(private readonly api: SettingsApi) {}

  public async settingsShouldPersistAnyUserActionsGet(
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<boolean> {
    return this.api.settingsShouldPersistAnyUserActionsGet(initOverrides);
  }

  public async settingsUploadNewTermsOfUsePost(initOverrides?: RequestInit | InitOverrideFunction): Promise<object> {
    return this.api.settingsUploadNewTermsOfUsePost(initOverrides);
  }
}
